module.exports = __webpack_public_path__ + "static/media/notification.3a547238.mp3";